import { ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import TextInputWithLabel from 'components/textInputWithLabel/TextInputWithLabel';
import { useTypedSelector } from 'utils/hooks';
import { setStagingFeedbackData } from 'actions/ruleEngines';
import { IModifiedFeedback } from 'components/RuleEngineCollection/types';
import * as Styles from '../styles';

interface StringInputTypeFeedbackProps {
  eachFeedbackData: IModifiedFeedback;
  viewMode: boolean;
}

const StringInputTypeFeedback = ({
  eachFeedbackData,
  viewMode = false,
}: StringInputTypeFeedbackProps) => {
  const eachFeedbackDataInStaging = useTypedSelector(
    store =>
      store.ruleEngine.stagingfeedbackData[eachFeedbackData.attributeName]
  );
  const dispatch = useDispatch();

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    dispatch(
      setStagingFeedbackData(eachFeedbackData.attributeName, [
        event.target.value,
      ])
    );
  }

  return (
    <Styles.StringInputWrapper>
      <TextInputWithLabel
        datalabel={eachFeedbackData.attributeName}
        placeholder="Type Text"
        dataname={eachFeedbackData.attributeName}
        value={eachFeedbackDataInStaging.attributeOptions[0]}
        onChange={handleChange}
        isDisabled={viewMode}
        shouldAutoFocus={false}
      />
    </Styles.StringInputWrapper>
  );
};

export default StringInputTypeFeedback;
